import { DocumentType } from '@tcs/client-portal-api/platform_generated';
import { useQuery } from '@tcs/common/hooks/useQuery';

interface Props {
  loading: boolean;
  data: string[];
}

export const useDocumentYears = (
  accountNumber: string,
  type: DocumentType
): Props => {
  const { data, isLoading: loading } = useQuery<[string], Error>(
    `/documents/account/${accountNumber}/years?type=${type}`,
    {
      refetchOnMount: false,
      enabled: accountNumber !== undefined,
    }
  );

  const sortedYears = data
    ? [...data].sort((a, b) => parseInt(b) - parseInt(a))
    : data;

  return {
    loading,
    data: sortedYears,
  };
};

export default useDocumentYears;
